import React from 'react';
export function Footer() {
  return <footer className="bg-brand-brown text-brand-sand py-10 text-center px-6" data-id="element-55">
      <div className="max-w-3xl mx-auto space-y-4" data-id="element-56">
        <p className="text-sm opacity-80 leading-relaxed" data-id="element-57">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
        <p className="text-sm opacity-80" data-id="element-58">
          &copy; {new Date().getFullYear()} Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}